/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventdescriptiontranslationstale3Inputs */

const en_eventdescriptiontranslationstale3 = /** @type {(inputs: Eventdescriptiontranslationstale3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The description changed since it was translated.`)
};

const de_eventdescriptiontranslationstale3 = /** @type {(inputs: Eventdescriptiontranslationstale3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Beschreibung hat sich seit der Übersetzung geändert.`)
};

/**
* | output |
* | --- |
* | "The description changed since it was translated." |
*
* @param {Eventdescriptiontranslationstale3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventdescriptiontranslationstale3 = /** @type {((inputs?: Eventdescriptiontranslationstale3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventdescriptiontranslationstale3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventdescriptiontranslationstale3(inputs)
	return de_eventdescriptiontranslationstale3(inputs)
});
export { eventdescriptiontranslationstale3 as "eventDescriptionTranslationStale" }